import { useTranslation } from "react-i18next";
import { LANDING_CONTENT } from "../content";
import { PhotoSlot } from "./PhotoSlot";
import { Reveal } from "./Reveal";

// The subtle memorial thread (ADR-0055): the page's main frame is the bond with a
// living pet, but this quiet band gently acknowledges the keepsake-after-loss
// motive without dominating. Soft, warm, understated: a short line + one calm
// image. A dedicated /pamiatka page is a later, separate surface.
export function Memorial() {
  const { t } = useTranslation("landing");
  return (
    <section
      id="memorial"
      aria-labelledby="memorial-heading"
      className="bg-card py-[clamp(3.5rem,7vw,6rem)]"
    >
      <div className="mx-auto grid w-full max-w-5xl grid-cols-1 items-center gap-8 px-6 sm:px-8 md:grid-cols-[1fr_1.1fr] md:gap-12">
        <Reveal>
          <PhotoSlot
            image={LANDING_CONTENT.memorial}
            alt={t("memorial.imageAlt")}
            briefId="memorial"
            aspectClassName="aspect-[4/3]"
            label={t("memorial.imagePlaceholder")}
          />
        </Reveal>
        <Reveal delayMs={100}>
          <div className="max-w-md">
            <h2
              id="memorial-heading"
              className="text-balance font-display text-[clamp(1.5rem,1.1rem+1.6vw,2rem)] font-semibold leading-snug tracking-tight text-foreground"
            >
              {t("memorial.heading")}
            </h2>
            <p className="mt-4 text-pretty leading-relaxed text-foreground/80">
              {t("memorial.body")}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
